import { render, staticRenderFns } from "./MarketRtChart.vue?vue&type=template&id=489dfd2f&scoped=true&lang=pug"
import script from "./MarketRtChart.vue?vue&type=script&lang=js"
export * from "./MarketRtChart.vue?vue&type=script&lang=js"
import style0 from "./MarketRtChart.vue?vue&type=style&index=0&id=489dfd2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489dfd2f",
  null
  
)

export default component.exports